import React, { useState, useEffect, useMemo, useCallback } from 'react';
import './gallery.css';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

function Gallery() {
    const [ref, isVisible] = useScrollAnimation(0.2);
    const photos = useMemo(() => ['images/4.jpg', 'images/2.jpg', 'images/3.jpg', 'images/5.jpg', 'images/1.jpg'], []);
    const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);
    const [isHovering, setIsHovering] = useState(false);

    const nextPhoto = useCallback(() => {
        setCurrentPhotoIndex((prevIndex) => (prevIndex + 1) % photos.length);
    }, [photos.length]);

    const prevPhoto = useCallback(() => {
        setCurrentPhotoIndex((prevIndex) => (prevIndex - 1 + photos.length) % photos.length);
    }, [photos.length]);

    useEffect(() => {
        const interval = setInterval(() => {
            if (!isHovering) {
                nextPhoto();
            }
        }, 3000); // Change photo every 3 seconds, adjust as needed
        return () => clearInterval(interval);
    }, [isHovering, nextPhoto]);

    

    return (
        <section id='gallery' className={`fade-in-section ${isVisible ? 'is-visible' : ''}`} ref={ref}>
            <h1>Gallery</h1>
            <div className="photo-switcher-container" onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)}>
                {photos.map((photo, index) => (
                    <img
                        key={photo}
                        src={photo}
                        alt={`Energy Corporation facility ${index + 1}`}
                        loading="lazy"
                        className={`photo-switcher-img ${index === currentPhotoIndex ? 'active' : ''}`}
                    />
                ))}
                <div className="photo-switcher-navigation">
                    <button 
                        className="photo-switcher-button" 
                        onClick={prevPhoto}
                        aria-label="Previous photo"
                    >
                        &lt; Prev
                    </button>
                    <button 
                        className="photo-switcher-button" 
                        onClick={nextPhoto}
                        aria-label="Next photo"
                    >
                        Next &gt;
                    </button>
                </div>
                <div className="photo-indicators">
                    {photos.map((_, index) => (
                        <button
                            key={index}
                            className={`indicator ${index === currentPhotoIndex ? 'active' : ''}`}
                            onClick={() => setCurrentPhotoIndex(index)}
                            aria-label={`Go to photo ${index + 1}`}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Gallery;

